import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import SponsorsContainer from "./sponsors/container";
import { ROUTES } from "../../routing/routes";
import { IModalContext, ModalContext } from "../../providers/Modal";
import { COOKIES } from "../../data/enums";
import Cookies from "js-cookie";
import _environment from "../../_environment/_environment";

declare const $: any;

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {}

const HomeView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to modal manager hook that you may use to open and close modals.
  const { openModal } = useContext<IModalContext>(ModalContext);

  // Fair clickable map sections
  const SECTIONS: any[] = [
    {
      classes: "top left",
      title: t("pages.standsList.title"),
      onClick: () => navigateTo(ROUTES.STANDS),
    },
    {
      classes: "top center sponsors-wrapper visible",
      title: t("pages.standsList.title"),
      render: <SponsorsContainer />,
      noAnimation: true,
    },
    {
      classes: "top right",
      title: t("pages.eventsList.title"),
      onClick: () => navigateTo(ROUTES.EVENTS),
    },
    {
      classes: "bottom left",
      title: t("pages.home.chat"),
      onClick: () => navigateTo(ROUTES.CHAT),
    },
    {
      classes: "bottom center",
      title: t("pages.home.infoPoint.title"),
      onClick: () =>
        openModal({
          size: "sm",
          customContent: renderInfoModal(),
          callback: () => {},
        }),
    },
    {
      classes: "bottom right",
      title: t("pages.home.internationalClub.title"),
      onClick: () =>
        openModal({
          size: "sm",
          customContent: renderB2BModal(),
          callback: () => {},
        }),
    },
  ];

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [activeSections, setActiveSections] = useState<number[]>([]);
  const [initialIntroVideoCookieValue, setInitialIntroVideoCookieValue] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------
  const player: any = React.createRef();

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Skips the intro video
   * @function
   */
  const skipVideo = () => {
    player.current.pause();
    $(".overlay").fadeOut(800);
    animateFirstSection();
  };

  /**
   * Navigates to a defined path
   * @function
   *
   * @param path
   */
  const navigateTo = (path: string) => {
    history.push(path);
  };

  /**
   * Animate first section
   * @function
   */
  const animateFirstSection = () => {
    // Animate the first available section: this will start the animation of the remaining sections
    setActiveSections([0]);
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Renders info modal content
   * @function
   */
  const renderInfoModal = (): React.ReactNode => {
    return (
      <>
        <h2>{t("pages.home.infoPoint.title")}</h2>

        <p className="mb-4">
          {t("pages.home.infoPoint.description1")}
          <br />

          <a
            href={`tel:${_environment.whatsapp.number}`}
            rel="noopener noreferrer"
            className="btn btn-default btn-flex m-4"
          >
            {t("pages.home.infoPoint.buttonText1")}
          </a>
        </p>

        <p className="mb-4">
          {t("pages.home.infoPoint.description2")}
          <br />
          <a
            href="https://www.remtechexpodigitaledition.it/"
            target="_blank"
            className="btn btn-default btn-flex m-4"
          >
            {t("pages.home.infoPoint.buttonText2")}
          </a>
        </p>

        <p className="mb-4">
          {t("pages.home.infoPoint.description3")} <br />
          <a
            className="btn btn-default btn-flex m-4"
            href="/assets/pdf/catalogo-espositori-digital-edition-2020.pdf"
            target="_blank"
          >
            {t("pages.home.infoPoint.buttonText3")}
          </a>
        </p>
      </>
    );
  };

  /**
   * Renders B2B modal content
   * @function
   */
  const renderB2BModal = (): React.ReactNode => {
    return (
      <>
        <h2>{t("pages.home.internationalClub.title")}</h2>

        <p className="mb-4">{t("pages.home.internationalClub.description1")}</p>
        <a className="btn btn-primary btn-primary btn-flex m-4" href={ROUTES.STANDS}>
          {t("pages.home.internationalClub.buttonText1")}
        </a>

        <p className="mt-4">{t("pages.home.internationalClub.description2")}</p>
        <a className="btn btn-primary btn-outline btn-flex m-4" href={`${_environment.mattermost.URL}/international`} target="_blank">
          {t("pages.home.internationalClub.buttonText2")} <i className="fas fa-comments"></i>
        </a>
      </>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[HomeView] init");

    setInitialIntroVideoCookieValue(!!Cookies.get(COOKIES.INTRO_VIDEO));

    $(".navbar").addClass("home");

    if (!Cookies.get(COOKIES.INTRO_VIDEO)) {
      player.current.play();

      Cookies.set(COOKIES.INTRO_VIDEO, "true", { path: "" });

      player.current.addEventListener("ended", () => {
        $(".overlay").fadeOut(800);
        animateFirstSection();
      });
    } else {
      $(".overlay").hide();
    }
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[HomeView] destroy");
    $(".navbar").removeClass("home");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to activeSections in order to handle entrance animations
   */
  useEffect(() => {
    // Check that the animation array is not empty and does not exceed the number of sections
    if (
      activeSections.length > 0 &&
      activeSections.length < SECTIONS.length &&
      !initialIntroVideoCookieValue
    ) {
      // Set the next index
      let nextIndex = activeSections[activeSections.length - 1] + 1;
      // Increase the next index until I find one that can be animated
      while (SECTIONS[nextIndex] && SECTIONS[nextIndex].noAnimation && SECTIONS[nextIndex + 1]) {
        nextIndex++;
      }
      // If the next index is a valid index, add it to the animation array
      if (SECTIONS[nextIndex] && !SECTIONS[nextIndex].noAnimation) {
        setTimeout(() => setActiveSections([...activeSections, ...[nextIndex]]), 250);
      }
    }
  }, [activeSections]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="home-page">
        <div className="overlay">
          <video width="320" height="240" muted ref={player}>
            <source src="/assets/videos/intro_black.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="controls">
            <span className="control" onClick={() => skipVideo()}>
              {t("pages.home.skipVideo")}
            </span>
          </div>
        </div>
        {SECTIONS.map((section: any, i) => (
          <div
            key={`section-${i}`}
            className={`${section.classes} animate__animated ${
              initialIntroVideoCookieValue ? "visible" : ""
            } ${activeSections.includes(i) ? "visible animate__zoomInDown" : ""}`}
            onClick={section.onClick || undefined}
          >
            {section.render || <h1>{section.title}</h1>}
          </div>
        ))}
      </div>
    </>
  );
};
export default HomeView;
